import React from 'react';
import Card from '../common/Card';
import Badge from '../common/Badge';
import Button from '../common/Button';
import { theme } from '../../config/theme';
import { EditIcon, TrashIcon, CheckIcon } from '../icons/Icons';

const AddressCard = ({ address, onEdit, onDelete, onSetDefault }) => {
  const { id, label, full_name, phone, address_line1, address_line2, city, state, postal_code, country, is_default } = address;

  return (
    <Card padding="lg" style={{ position: 'relative' }}>
      {is_default && (
        <Badge variant="success" style={{ position: 'absolute', top: theme.spacing.md, right: theme.spacing.md }}>
          <CheckIcon size={14} />
          Default
        </Badge>
      )}

      <div style={{ marginBottom: theme.spacing.md }}>
        <span style={{
          display: 'inline-block',
          padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
          backgroundColor: theme.colors.gray[100],
          borderRadius: theme.borderRadius.sm,
          fontSize: theme.typography.fontSize.xs,
          fontWeight: theme.typography.fontWeight.medium,
          textTransform: 'uppercase',
          marginBottom: theme.spacing.sm,
        }}>
          {label}
        </span>
      </div>

      <div style={{ marginBottom: theme.spacing.lg }}>
        <div style={{ fontWeight: theme.typography.fontWeight.semibold, marginBottom: theme.spacing.xs }}>
          {full_name}
        </div>
        <div style={{ fontSize: theme.typography.fontSize.sm, color: theme.colors.text.secondary }}>
          {address_line1}
          {address_line2 && <>, {address_line2}</>}
        </div>
        <div style={{ fontSize: theme.typography.fontSize.sm, color: theme.colors.text.secondary }}>
          {city}, {state} {postal_code}
        </div>
        <div style={{ fontSize: theme.typography.fontSize.sm, color: theme.colors.text.secondary }}>
          {country}
        </div>
        <div style={{ fontSize: theme.typography.fontSize.sm, color: theme.colors.text.secondary, marginTop: theme.spacing.xs }}>
          Phone: {phone}
        </div>
      </div>

      <div style={{ display: 'flex', gap: theme.spacing.sm, flexWrap: 'wrap' }}>
        {!is_default && (
          <Button size="sm" variant="secondary" onClick={() => onSetDefault(id)}>
            Set as Default
          </Button>
        )}
        <Button size="sm" variant="ghost" onClick={() => onEdit(address)}>
          <EditIcon size={16} />
          Edit
        </Button>
        <Button size="sm" variant="ghost" onClick={() => onDelete(id)} style={{ color: theme.colors.error }}>
          <TrashIcon size={16} />
          Delete
        </Button>
      </div>
    </Card>
  );
};

export default AddressCard;